import type { CSSProperties, ReactNode } from 'react';

export type BadgeTone =
  | 'sage'
  | 'sand'
  | 'terracotta'
  | 'sky'
  | 'sun'
  | 'admin-blue'
  | 'admin-green'
  | 'admin-amber'
  | 'admin-red'
  | 'admin-violet'
  | 'admin-neutral';

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  withDot?: boolean;
  style?: CSSProperties;
}

const toneStyles: Record<BadgeTone, { color: string; background: string; dot?: string }> = {
  sage: { color: '#fff', background: 'var(--sage)' },
  sand: { color: 'var(--ink-soft)', background: 'var(--sand)' },
  terracotta: { color: '#fff', background: 'var(--terracotta)' },
  sky: { color: 'var(--ink-soft)', background: 'var(--sky)' },
  sun: { color: 'var(--ink-soft)', background: 'var(--sun)' },
  'admin-blue': { color: 'var(--a-blue)', background: 'var(--a-blue-soft)' },
  'admin-green': { color: 'var(--a-green)', background: 'var(--a-green-soft)' },
  'admin-amber': { color: 'var(--a-amber)', background: 'var(--a-amber-soft)' },
  'admin-red': { color: 'var(--a-red)', background: 'var(--a-red-soft)' },
  'admin-violet': { color: 'var(--a-violet)', background: 'var(--a-violet-soft)' },
  'admin-neutral': { color: 'var(--a-ink-soft)', background: 'var(--a-line-soft)' },
};

export function Badge({ tone = 'sand', children, withDot, style }: BadgeProps) {
  const t = toneStyles[tone];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '3px 8px',
        borderRadius: 6,
        fontSize: 11,
        fontWeight: 600,
        color: t.color,
        background: t.background,
        fontFamily: 'var(--sans)',
        letterSpacing: 0.2,
        ...style,
      }}
    >
      {withDot && (
        <span
          style={{
            width: 5,
            height: 5,
            borderRadius: 999,
            background: t.color,
          }}
        />
      )}
      {children}
    </span>
  );
}
